import { FC } from 'react';

import CapsuleTypeAddComponent from 'components/main/CapsuleType/Add';

const CapsuleTypeAdd: FC = () => <CapsuleTypeAddComponent />;

export default CapsuleTypeAdd;
